<template>
  <div class="addSuppliesPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="applyName"
        clearable
        label="所属采购："
        :placeholder="commonType == 'addType' ? '请选择' : ''"
        readonly
        :is-link="commonType == 'addType'"
        @click="getSupplies"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary selectMaterialBox">
      <div class="selectMaterial">
        <p>所属材料:</p>
        <span @click="getMaterial" class="addTopic fl" v-if="applyName != ''">
          <van-icon name="add-o" class="topicIcon" />添加材料
        </span>
      </div>
      <ul class="materialNamelists" v-if="materialNamelist.length != '0'">
        <li
          class="materiallist"
          v-for="(item, index) in materialNamelist"
          :key="index"
        >
          {{ item.materialName }}
          <span @click="deletToplist(item.id, index)">×</span>
        </li>
      </ul>
    </van-cell-group>
    <div class="materialInfoBox">
      <ul class="materaInfo">
        <li v-for="(item, index) in applyPurchaseItemIdsData" :key="index">
          <h4>材料{{ convertToChinese(index + 1) }}</h4>
          <div class="baseWzMsg">
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.materialType"
                required
                :readonly="!editType"
                clearable
                label="类型："
                :placeholder="editType ? '请输入... ' : ''"
                class="ggInput"
              />
              <van-field
                v-model="item.total"
                required
                :readonly="!editType"
                clearable
                type="digit"
                @input="storageNumberChange(item)"
                label="入库数量："
                :placeholder="editType ? '请输入... ' : ''"
                class="ggInput"
              />

              <van-field
                v-model="item.unit"
                clearable
                label="单位："
                :readonly="!editType"
                required
                :placeholder="editType ? '请输入... ' : ''"
                class="ggInput"
              />
              <van-field
                v-model="item.materialNatureName"
                readonly
                required
                is-link
                label="属性："
                placeholder="请选择"
                class="ggInput"
                @click="changeNature(item, index)"
              />
              <van-field
                v-if="item.materialNature == 'yhp'"
                v-model="item.materialChildTypeName"
                readonly
                required
                is-link
                label="易耗品子类型："
                placeholder="请选择易耗品子类型"
                class="ggInput"
                @click="changeChildType(item, index)"
              />
              <van-field
                v-if="item.materialNature == 'yhp'"
                v-model="item.postNames"
                readonly
                is-link
                type="textarea"
                rows="1"
                autosize
                label="适用岗位："
                :placeholder="editType ? '请选择' : ''"
                class="ggInput"
                @click="changeChildPost(item, index)"
              />
              <van-field
                v-if="item.materialNature == 'yhp'"
                v-model="item.userNames"
                type="textarea"
                readonly
                is-link
                rows="1"
                autosize
                label="适用人员："
                 :placeholder="editType ? '请选择' : ''"
                class="ggInput"
                @click="changeChildUser(item, index)"
              />
              <van-field
                v-if="item.materialNature == 'yhp'"
                v-model="item.deptNames"
                type="textarea"
                readonly
                is-link
                rows="1"
                autosize
                label="适用部门："
                :placeholder="editType ? '请选择' : ''"
                class="ggInput"
                @click="changeChildDept(item, index)"
              />
              <van-field
                v-model="item.purchaseDate"
                readonly
                is-link
                label="购入日期："
                :placeholder="editType ? '请选择' : ''"
                class="ggInput"
                @click="payTimePicker(index)"
              />
            </van-cell-group>
          </div>
          <ul class="wzListInfo">
            <li
              v-for="(itemChild, childIndex) in item.amountData"
              :key="childIndex"
            >
              <!-- <van-cell-group class="baseNone baseSalary">
                <van-field
                  v-model="itemChild.code"
                  clearable
                  required
                  :label="'编号' + convertToChinese(childIndex + 1) + ':'"
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group> -->
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  v-model="itemChild.materialName"
                  clearable
                  label="名称："
                  required
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  v-model="itemChild.modelNumber"
                  clearable
                  label="品牌型号："
                  required
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  type="number"
                  v-model="itemChild.price"
                  clearable
                  label="单价："
                  required
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary jjz">
                <van-field
                  type="digit"
                  v-model="itemChild.warningLimit"
                  clearable
                  label="警戒值："
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="itemChild.remarks"
                  rows="1"
                  autosize
                  input-align="right"
                  type="textarea"
                  clearable
                  label="备注："
                  placeholder="请输入... "
                  class="ggInput"
                />
              </van-cell-group>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- 新增状态下提交 -->
    <div class="btnBox">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 弹出框 -->
    <!-- 采购列表 -->
    <van-popup v-model="showSuppliesPicker" position="bottom" class="roleBox">
      <search-supplies @setItems="setSupplies"></search-supplies>
    </van-popup>
    <!-- 所属材料列表 -->
    <van-popup
      v-model="showMaterialPicker"
      position="bottom"
      class="guardBox"
      @close="closeMaterialPicker"
    >
      <div class="roleHeader clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeMaterialPicker"
          >取消</a
        >
        请选择
        <a href="javascript:void(0);" class="fr" @click="saveMaterial">确认</a>
      </div>
      <van-checkbox-group v-model="selctIds">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in materialItemList"
            clickable
            :key="index"
            :title="`${item.materialName}`"
            @click="toggle(index, item)"
          >
            <van-checkbox
              :name="item.id"
              ref="checkboxes"
              slot="right-icon"
              shape="square"
            />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
    <!-- 物资属性选择 -->
    <van-popup v-model="showNaturePicker" position="bottom" class="guardBox">
      <van-picker
        title="物资属性"
        show-toolbar
        value-key="label"
        :columns="materialNatureType"
        @confirm="saveMaterialType"
        @cancel="showNaturePicker = false"
      />
    </van-popup>
    <!-- 易耗品子属性选择 -->
    <van-popup v-model="showChildTypePicker" position="bottom" class="guardBox">
      <van-picker
        title="易耗品子属性"
        show-toolbar
        value-key="label"
        :columns="materialChildTypeData"
        @confirm="saveNatureChildType"
        @cancel="showChildTypePicker = false"
      />
    </van-popup>

    <!--  适用岗位管理 -->
    <van-popup v-model="showChildPostPicker" position="bottom" class="roleBox">
      <post-view
        :postIds="applyPurchaseItemIdsData[materialItemPostIndex].post"
        @setPostItems="setPost"
      ></post-view>
    </van-popup>
    <!--  适用人员 -->
    <van-popup v-model="showChildUserPicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="applyPurchaseItemIdsData[materialItemUserIndex].user"
        @setReview="setUsers"
      ></retinue-view>
    </van-popup>
    <!--  适用部门 -->
    <van-popup v-model="showChildDeptPicker" position="bottom" class="roleBox">
      <dept-view
        :deptIds="applyPurchaseItemIdsData[materialItemDeptIndex].dept"
        @setDeptData="setDepts"
      ></dept-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showPaytimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showPaytimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import {
  dateFormat,
  getDictList,
  dateTimeFormat,
  getCurData,
} from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
const searchSupplies = () =>
  import("@/views/materialsModule/suppliesManage/components/searchSupplies");
const selectMaterial = () =>
  import("@/views/materialsModule/suppliesManage/components/selectMaterial");
const postView = () => import("@/components/common/PostList");
const deptView = () => import("@/components/common/deptList");
const retinueView = () => import("@/components/businessTripMould/retinueView");
export default {
  name: "addSupplies",
  components: {
    searchSupplies,
    selectMaterial,
    postView,
    retinueView,
    deptView,
  },
  data() {
    return {
      commonType: "", //addType:点击新增,jumpType:点击入库新增
      editType: false, //false不可编辑
      applyName: "", //申请name
      applyPurchaseItemIds: [], //采购申请小项编码集
      materialItemList: [], //物资集合
      materialItemIndex: 0, //物资小项下标
      materialNamelist: [], //物资小项list
      applyPurchaseItemIdsData: [
        {
          materialNature: "", //属性
          materialNatureName: "", //属性名称
          materialChildType: "", //易耗品子类型名称
          materialChildTypeName: "", //易耗品子类型
          dept: [], //适用部门id
          deptNames: "",
          post: [], //适用岗位
          postNames: "",
          user: [], //适用人员id
          userNames: "",
          materialType: "", //类型
          total: "", //入库数量
          unit: "", //单位
          purchaseDate: "", //购入日期
          amountData: [
            {
              id: "",
              // code: "", //编号
              materialName: "", //名称
              warningLimit: "", //警戒值
              modelNumber: "", //型号
              price: "", //单价
              enable: true,
              remarks: "", //备注
            },
          ],
        },
      ], //所属材料数据
      materialNatureType: [
        //资产值
        {
          value: "gdzc",
          label: "固定资产",
        },
        {
          value: "yhp",
          label: "易耗品",
        },
      ],
      //易耗品子类型
      materialChildTypeData: [
        {
          value: "zdyp",
          label: "招待用品",
        },
        {
          value: "bgyp",
          label: "办公用品",
        },
      ],
      materialChildDeptData: [], //易耗品适用岗位list
      showChildTypePicker: false, //易耗品子类型弹框
      showChildPostPicker: false, //易耗品适用岗位
      materialItemPostIndex: 0,
      showChildDeptPicker: false, //易耗品适用部门
      materialItemDeptIndex: 0,
      showChildUserPicker: false, //易耗品适用人员
      materialItemUserIndex: 0,
      showNaturePicker: false,
      showSuppliesPicker: false,
      showMaterialPicker: false,
      showPaytimePicker: false,
      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 1, 1),
      selctIds: [],
      guarddata: [], //选中的角色列表
      multipleChoiceLength: 0, //选中的物资length
      materialNatureChange: "", //属性更改
      numberTotal: 0, //数量变化
      msgdata: [], //新的所属材料
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.setShowLoad(false); //加载状态，默认为true加载
    this.commonType = this.$route.query.commonType; //addType:点击新增,jumpType:点击入库新增
    this.commonId = this.$route.query.commonId; //点击入库新增的申请Id
    this.editType = this.commonType == "addType" ? true : false;
    this.commonType == "jumpType" ? this.getDetail() : "";
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    toggle(index, item) {
      //选择物资单项
      this.$refs.checkboxes[index].toggle();
      this.guarddata.push(this.materialItemList[index]);
      this.unique(this.guarddata);
    },
    convertToChinese(num) {
      //编号数字
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];

      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }

        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;

      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
    getDetail() {
      //详情
      let _this = this;
      _this.$api.material.procurementManage
        .detailsProcurement(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            this.setSupplies(res.data);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    getSupplies() {
      if (this.commonType == "addType") {
        this.showSuppliesPicker = true;
      }
    },
    setSupplies(data) {
      let _this = this;
      _this.showSuppliesPicker = false;
      if (this.commonType == "jumpType") {
        _this.editType = false;
      }
      if (data != "") {
        _this.editType = false;
        _this.applyName =
          data.applicantName + " - " + data.createTime.substr(0, 10);
        _this.multipleChoiceLength = _this.selctIds.length;
        _this.msgdata = [];
        data.itemList.forEach((item) => {
          if (!item.isInstorage) {
            _this.msgdata.push(item);
            _this.guarddata.push(item);
          }
        });
        _this.msgdata.forEach((item) => {
          _this.selctIds.push(item.id);
        });
        _this.msgdata.forEach((item) => {
          for (let key in item) {
            if (item[key] == null) {
              item[key] = "";
            }
          }
        });
        _this.materialNamelist = newApi.cloneDeep(_this.msgdata);
        _this.materialItemList = _this.msgdata;
        setTimeout(function () {
          _this.applyPurchaseItemIdsData = [];
          for (var i = 0; i < _this.msgdata.length; i++) {
            _this.applyPurchaseItemIdsData.push(_this.msgdata[i]);
          }
          _this.applyPurchaseItemIdsData.forEach((item) => {
            _this.$set(item, "total", item.purchaseAmount);
          });
          _this.applyPurchaseItemIdsData.forEach((item) => {
            _this.$set(item, "materialType", item.materialName);
          });
        }, 30);
      } else {
        if (_this.commonType == "addType") {
          _this.editType = true;
        }
        (_this.applyName = ""), (_this.multipleChoiceLength = 0);
        _this.msgdata = [];
        _this.materialNamelist = [];
        _this.materialItemList = [];
        setTimeout(function () {
          if (_this.msgdata.length > 0) {
            _this.applyPurchaseItemIdsData = [];
            for (var i = 0; i < _this.msgdata.length; i++) {
              _this.applyPurchaseItemIdsData.push(_this.msgdata[i]);
            }
            _this.applyPurchaseItemIdsData.forEach((item) => {
              _this.$set(item, "total", item.purchaseAmount);
            });
            _this.applyPurchaseItemIdsData.forEach((item) => {
              _this.$set(item, "materialType", item.materialName);
            });
          } else {
            _this.applyPurchaseItemIdsData = [
              {
                materialNature: "", //属性
                materialNatureName: "", //属性名称
                materialChildType: "", //易耗品子类型名称
                materialChildTypeName: "", //易耗品子类型
                materialType: "", //类型
                total: "", //入库数量
                unit: "", //单位
                dept: [], //适用部门id
                deptNames: "",
                post: [], //适用岗位
                postNames: "",
                user: [], //适用人员id
                userNames: "",
                purchaseDate: "", //购入日期
                amountData: [
                  {
                    id: "",
                    // code: "", //编号
                    materialName: "", //名称
                    warningLimit: "", //警戒值
                    modelNumber: "", //型号
                    enable: true,
                    price: "", //单价
                    remarks: "", //备注
                  },
                ],
              },
            ];
          }
        }, 30);
      }
      _this.getAmountData();
    },
    getAmountItemData(arr) {
      let _this = this;
      _this.applyPurchaseItemIdsData = [];
      setTimeout(function () {
        _this.applyPurchaseItemIdsData = [];
        if (arr.length == "0") {
          _this.applyPurchaseItemIdsData.push({
            materialNature: "", //属性
            materialNatureName: "", //属性名称
            materialChildType: "", //易耗品子类型名称
            materialChildTypeName: "", //易耗品子类型
            materialType: "", //类型
            total: "", //入库数量
            unit: "", //单位
            dept: [], //适用部门id
            deptNames: "",
            post: [], //适用岗位
            postNames: "",
            user: [], //适用人员id
            userNames: "",
            purchaseDate: "", //购入日期
            amountData: [
              {
                id: "",
                // code: "", //编号
                materialName: "", //名称
                warningLimit: "", //警戒值
                modelNumber: "", //型号
                enable: true,
                price: "", //单价
                remarks: "", //备注
              },
            ],
          });
        } else {
          for (let i = 0; i < arr.length; i++) {
            _this.msgdata.forEach((item) => {
              if (item.id == arr[i]) {
                _this.applyPurchaseItemIdsData.push(item);
              }
            });
          }
        }
      }, 30);
    },
    deletToplist(id, index) {
      let _this = this;
      _this.selctIds.forEach((item, itemIndex) => {
        if (item == id) {
          _this.selctIds.splice(itemIndex, 1);
        }
      });

      _this.materialNamelist.forEach((item, index) => {
        if (item.id == id) {
          _this.materialNamelist.splice(index, 1);
        }
      });
      _this.guarddata.forEach((item, index) => {
        if (item.id == id) {
          _this.guarddata.splice(index, 1);
        }
      });
      _this.multipleChoiceLength = _this.selctIds.length;
      if (_this.multipleChoiceLength == "0" && _this.commonType == "addType") {
        _this.editType = true;
      }
      this.getAmountItemData(_this.selctIds);
    },
    getMaterial() {
      //点击获取列表
      if (this.applyName != "") {
        this.showMaterialPicker = true;
      }
    },
    closeMaterialPicker() {
      //关闭物资选择
      this.showMaterialPicker = false;
    },
    saveMaterial() {
      let _this = this;
      _this.selctIds = [];
      _this.materialNamelist = newApi.cloneDeep(_this.guarddata);
      this.showMaterialPicker = false;
      _this.guarddata.forEach((item) => {
        _this.selctIds.push(item.id);
      });
      _this.multipleChoiceLength = _this.selctIds.length;
      this.getAmountItemData(_this.selctIds);
    },
    changeNature(item, index) {
      //选择属性
      this.showNaturePicker = true;
      this.materialItemIndex = index;
    },
    saveMaterialType(data) {
      //保存物资属性
      this.$set(
        this.applyPurchaseItemIdsData[this.materialItemIndex],
        "materialNature",
        data.value
      );
      this.$set(
        this.applyPurchaseItemIdsData[this.materialItemIndex],
        "materialNatureName",
        data.label
      );
      this.materialNatureDataChange(
        this.applyPurchaseItemIdsData[this.materialItemIndex]
      );
      this.showNaturePicker = false;
    },
    changeChildType(item, index) {
      //选择易耗品子类型
      this.showChildTypePicker = true;
      this.materialItemIndex = index;
    },
    saveNatureChildType(data) {
      //保存易耗品子属性
      this.$set(
        this.applyPurchaseItemIdsData[this.materialItemIndex],
        "materialChildType",
        data.value
      );
      this.$set(
        this.applyPurchaseItemIdsData[this.materialItemIndex],
        "materialChildTypeName",
        data.label
      );
      this.showChildTypePicker = false;
    },
    changeChildPost(item, index) {
      //选择适用岗位
      this.showChildPostPicker = true;
      this.materialItemPostIndex = index;
    },
    setPost(data) {
      console.log(data);
      if (data != "") {
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemPostIndex],
          "post",
          data.id
        );
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemPostIndex],
          "postNames",
          data.name
        );
      }
      this.showChildPostPicker = false;
    },
    changeChildDept(item, index) {
      //选择适用部门
      this.showChildDeptPicker = true;
      this.materialItemDeptIndex = index;
      console.log(
        this.applyPurchaseItemIdsData[this.materialItemDeptIndex].dept
      );
    },
    setDepts(data) {
      if (data != "") {
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemDeptIndex],
          "dept",
          data.ids
        );
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemDeptIndex],
          "deptNames",
          data.names
        );
        console.log(data);
      }
      this.showChildDeptPicker = false;
    },
    changeChildUser(item, index) {
      //选择使用人员
      this.showChildUserPicker = true;
      this.materialItemUserIndex = index;
    },
    setUsers(data) {
      if (data != "") {
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemUserIndex],
          "user",
          data.ids
        );
        this.$set(
          this.applyPurchaseItemIdsData[this.materialItemUserIndex],
          "userNames",
          data.names
        );
        console.log(data);
      }
      this.showChildUserPicker = false;
    },
    payTimePicker(index) {
      //选择购入时间
      this.showPaytimePicker = true;
      this.materialItemIndex = index;
    },
    onTimeConfirm(data) {
      //保存购入时间
      this.$set(
        this.applyPurchaseItemIdsData[this.materialItemIndex],
        "purchaseDate",
        dateFormat(data)
      );
      this.showPaytimePicker = false;
    },
    //物资列表切换
    getCGData() {
      this.applyPurchaseItemIdsData = [];
      for (var i = 0; i < this.multipleChoiceLength; i++) {
        this.applyPurchaseItemIdsData.push({
          materialNature: "", //属性
          materialType: "", //类型
          total: "", //入库数量
          unit: "", //单位
          purchaseDate: "", //购入日期
          amountData: [],
        });
      }
    },
    getAmountData() {
      //物资列表小项
      this.applyPurchaseItemIdsData.forEach((item) => {
        this.$set(item, "amountData", []);
        if (item.materialNature == "gdzc") {
          // item.amountData = [];
          for (var i = 0; i < item.total; i++) {
            item.amountData.push({
              id: item.id == "" ? "" : item.id,
              // code: "", //编号
              materialName: "", //名称
              warningLimit: "", //警戒值
              modelNumber: item.modelNumber == null ? "" : item.modelNumber, //型号
              enable: true,
              price: item.price == null ? "" : item.price, //单价
              remarks: "", //备注
            });
          }
          console.log(item.amountData);
        } else {
          item.amountData = [
            {
              id: item.id == "" ? "" : item.id,
              // code: "", //编号
              materialName: "", //名称
              warningLimit: "", //警戒值
              modelNumber: item.modelNumber == null ? "" : item.modelNumber, //型号
              enable: true,
              price: "", //单价
              remarks: "", //备注
            },
          ];
        }
      });
    },

    materialNatureDataChange(item) {
      // 监听属性修改
      this.materialNatureChange = item.materialNature;
    },
    storageNumberChange(item) {
      //监听数量更改
      this.numberTotal = item.total;
      if (item.total <= 0) {
        this.$toast("入库数量不能为负数或者0");
      }
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) =>
            item1.materialName === item2.materialName && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.guarddata = _this.guarddata.filter(function () {
        return true;
      });
    },
    checkInput() {
      let reserveList = [];
      let flag = true;
      this.applyPurchaseItemIdsData.forEach((item) => {
        item.amountData.forEach((items) => {
          let obj = {};
          obj.id = items.id;
          // obj.code = items.code;
          obj.materialName = items.materialName;
          obj.warningLimit = items.warningLimit;
          obj.modelNumber = items.modelNumber;
          obj.enable = items.enable;
          obj.remarks = items.remarks;
          obj.materialType = item.materialType;
          obj.materialNature = item.materialNature;
          item.materialNature == "yhp"
            ? (obj.materialChildType = item.materialChildType)
            : "";
          // item.materialNature == "yhp"
          //   ? (obj.dept = item.dept[0] ? item.dept : "")
          //   : "";
          // item.materialNature == "yhp"
          //   ? (obj.post = item.post[0] ? item.post : "")
          //   : "";
          // item.materialNature == "yhp"
          //   ? (obj.user = item.user[0] ? item.user : "")
          //   : "";
          obj.price = items.price;
          obj.unit = item.unit;
          obj.purchaseDate = item.purchaseDate;
          obj.total = item.materialNature == "yhp" ? item.total : "1";
          reserveList.push(obj);
        });
        console.log(reserveList);
      });
      console.log(reserveList);
      reserveList.forEach((item) => {
        for (let key in item) {
          if (
            item[key] === "" &&
            key != "remarks" &&
            key != "warningLimit" &&
            key != "purchaseDate" &&
            key != "dept" &&
            key != "deptNamdes" &&
            key != "post" &&
            key != "postNamdes" &&
            key != "user" &&
            key != "userNamdes" &&
            key != "id"
          ) {
            flag = false;
            this.$toast("带星号为必填,不能为空");
          }
        }
      });
      if (flag) {
        this.saveSupplies(reserveList);
      }
    },
    saveSupplies(reserveList) {
      let _this = this;
      let param = {
        applyPurchaseItemIds: _this.selctIds,
        reserveList: reserveList,
      };
      _this.btnLoading = true;
      _this.$api.material.materialManage
        .save("add", param)
        .then((res) => {
          if (res.code == "1" && res.success == true) {
            console.log("添加成功");
            let text = "添加成功";
            if (_this.clientType == "android") {
              window.android.getInfo(113);
            } else {
              window.webkit.messageHandlers.reviewType.postMessage(null);
            }
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    multipleChoiceLength() {
      this.getCGData();
    },
    numberTotal() {
      this.getAmountData();
    },
    materialNatureChange() {
      this.getAmountData();
    },
  },
};
</script>
<style lang="less">
.addSuppliesPage {
  .ggInput {
    .van-cell__title {
      width: 150px;
    }
  }
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  padding-bottom: 75px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  h4 {
    position: relative;
    border-bottom: 1px solid #ebedf0;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  h4:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 25px;
    background: #2581d6;
    top: 10px;
    left: 10px;
    bottom: 5px;
  }

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
    .ggInput {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone::after {
    content: none;
  }
  //所属材料
  .selectMaterialBox {
    border-bottom: 1px solid #ebedf0;
    min-height: 45px;
    .selectMaterial {
      padding: 10px 16px;
      position: relative;
      width: 100%;
      > p {
        font-size: 15px;
      }
      .addTopic {
        color: #2581d6;
        line-height: 25px;
        font-size: 15px;
        padding-left: 15px;
        position: absolute;
        top: 10px;
        right: 16px;
        .topicIcon {
          font-size: 15px;
          position: absolute;
          top: 5px;
          left: 0;
        }
      }
    }
    .materialNamelists {
      width: 100%;
      padding: 0 16px;
      overflow: hidden;

      .materiallist {
        font-size: 14px;
        display: inline-block;
        padding: 5px 8px;
        border: 1px solid #ebedf0;
        position: relative;
        margin: 10px 15px;
        span {
          display: block;
          width: 15px;
          height: 15px;
          color: red;
          text-align: center;
          font-size: 12px;
          background-color: #fff;
          border: 1px solid #eee;
          border-radius: 50%;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          position: absolute;
          top: -5px;
          right: -7px;
        }
      }
    }
  }
  //列表结合
  .materialInfoBox {
    .ggInput.van-cell::after {
      content: none;
    }
    ul.materaInfo {
      width: 100%;
      padding: 0 16px;

      li {
        margin: 8px 0;
        border: 1px solid #ebedf0;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        > p {
          padding: 10px 16px;
          border-bottom: 1px solid #ebedf0;
        }
      }
    }
    ul.wzListInfo {
      width: 100%;
      padding: 0 8px;

      li {
        border: 1px solid #ebedf0;
        margin: 8px 0;
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        .beizhu {
          .ggInput {
            border-bottom: 0 none;
          }
        }
      }
    }
  }

  .guardBox {
    width: 100%;
    height: 50%;
    padding-top: 5px;
    // overflow-y: initial;
    .roleHeader {
      position: relative;
      font-size: 15px;
      text-align: center;
      color: #333;
      border-bottom: 1px solid #f6f6f6;
      height: 15%;
      padding: 10px 0;
      a:first-child {
        color: rgb(235, 199, 155);
      }
      a {
        height: 100%;
        padding: 0 16px;
        color: #07c160;
        font-size: 15px;
      }
    }
    .roleMain {
      height: 85%;
      overflow-y: scroll;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>